export { default as UserCompetenciesSelectFieldAlertMessage } from './UserCompetenciesSelectFieldAlertMessage';
